import type { AppConfig } from "../../types/appConfig";
import type { PortalResponse } from "./Portal.typed";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";

export class PortalModel {
  private zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async getPortalCustomerInfo(token: string): Promise<PortalResponse> {
    const response = await fetchZekay(this.zekayAPI + "/portal/v2/info", {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    await assertResponseOk(response);

    return (await response.json()) as PortalResponse;
  }

  async updatePortalCustomerInfo(formData: FormData, token: string): Promise<void> {
    const response = await fetchZekay(this.zekayAPI + "/portal/v2/info", {
      method: "POST",
      headers: { Authorization: token },
      body: formData,
    });
    await expectStatuses(response, 204);
  }
}
